export const discountFilterState = () => ({
  page: 1,
  perPage: 10,
  endDate: null,
  startDate: null,
  statuses: ["upcoming", "ongoing", "ended", "cancelled"],
});
